import {withState} from 'recompose';
import PropType from 'prop-types';
import ArticlePage from './articlePage';
import {Container, Button, ArticleTeasers} from './styles';
import {SmallTitle, MainTitleDark} from 'ui';

const ArticleList = ({pages, setPages, endReached, setEndReached}) => {
  const onEndReached = () => {
    setEndReached(true);
    setPages(pages - 1);
  };
  const articlePages = [];
  for (let page = 1; page <= pages; page++) {
    articlePages.push(<ArticlePage onEndReached={onEndReached} key={page} page={page} />);
  }
  return (
    <Container>
      <SmallTitle>EN CE MOMENT</SmallTitle>
      <MainTitleDark>Tous les articles</MainTitleDark>
      <ArticleTeasers>{articlePages.map(articlePage => articlePage)}</ArticleTeasers>
      {!endReached && <Button onClick={() => setPages(pages + 1)}>Voir plus d’articles</Button>}
    </Container>
  );
};

ArticleList.propTypes = {
  pages: PropType.number.isRequired,
  setPages: PropType.func.isRequired,
  endReached: PropType.bool.isRequired,
  setEndReached: PropType.func.isRequired,
};

export default ArticleList
  |> withState('pages', 'setPages', 1)
  |> withState('endReached', 'setEndReached', false);
